import { useEffect, useRef } from "react";
import { ClipboardTextIcon, XIcon } from "@phosphor-icons/react";

function ModalCamposFaltantes({ campos, onClose, onReview }) {
  const botonRef = useRef(null);

  useEffect(() => {
    botonRef.current?.focus();
    function cerrarConEscape(evento) {
      if (evento.key === "Escape") onClose();
    }
    document.addEventListener("keydown", cerrarConEscape);
    return () => document.removeEventListener("keydown", cerrarConEscape);
  }, [onClose]);

  return (
    <div className="required-modal" role="presentation">
      <div className="required-modal__dialog" role="alertdialog" aria-modal="true" aria-labelledby="required-title" aria-describedby="required-copy">
        <button className="required-modal__close" type="button" onClick={onClose} aria-label="Cerrar"><XIcon weight="bold" /></button>
        <span className="required-modal__icon"><ClipboardTextIcon weight="duotone" /></span>
        <h2 id="required-title">Falta información obligatoria</h2>
        <p id="required-copy">Completa estos datos para continuar:</p>
        <ul>{campos.map((campo) => <li key={campo}>{campo}</li>)}</ul>
        <button className="required-modal__review" type="button" onClick={onReview} ref={botonRef}>Revisar campos</button>
      </div>
    </div>
  );
}

export default ModalCamposFaltantes;
